import { useBoolean } from 'react-easyrocket';
import { twJoin } from 'tailwind-merge';
import classNames from 'classnames';
import { ArrowSeo } from '../../../svg/Arrows';
import { useGetSeoPageData } from 'src/hooks/useGetSeoPageData';

export const FooterSeoBlock = () => {
  const [isOpened, , , toggleIsOpened] = useBoolean(false);

  const pageToDisplay = useGetSeoPageData();
  if (!pageToDisplay || !pageToDisplay.content) return null;

  return (
    <div className="bg-fsb_bg">
      <div className="relative mb-5">
        <div
          className={twJoin(
            'content z-10 grid overflow-hidden px-5 text-fsb_text transition-all',
            isOpened ? 'max-h-full' : 'max-h-[285px]',
            '[&_p]:text-sm 768:[&_p]:text-lg',
            '[&_h1]:my-[9px] [&_h1]:text-xl [&_h1]:font-black 768:[&_h1]:text-2xl',
            '[&_h2]:my-[9px] [&_h2]:text-lg [&_h2]:font-black 768:[&_h2]:text-xl',
            '[&_h3]:my-[9px] [&_h3]:text-base [&_h3]:font-black 768:[&_h3]:text-lg',
            '[&_a]:text-gc_bg_label_bonus [&_a]:underline',
            '[&_ul]:list-disc [&_ul]:py-5 [&_ul]:pl-10',
            '[&_ol]:list-decimal [&_ol]:py-5 [&_ol]:pl-10'
          )}>
          <div dangerouslySetInnerHTML={{ __html: pageToDisplay.content }} />
        </div>
        {!isOpened && (
          <div
            className="absolute bottom-0 z-20 h-[50%] w-full"
            style={{
              background:
                'linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(12, 19, 25, 0) -83.83%, rgb(12, 19, 25) 93.77%)'
            }}
          />
        )}
      </div>
      <ArrowSeo
        openList={toggleIsOpened}
        className={classNames(
          'm-auto w-5 cursor-pointer h-full stroke-[3px] stroke-text_1 transition-transform',
          { opened: isOpened }
        )}
      />
    </div>
  );
};
